@let request = $request();
@let isLoading = isLoading$ | async;
@let isInitialLoad = $isInitialLoad();
@let formatDateWithLocale = $formatDateWithLocale();
@let getCheckList = $getCheckList();
@let shareRequestLink = $shareRequestLink();
@let isOpeningEpts = $isOpeningEpts();
@let ePTS = $ePTS();
@let openYaMaps = $openYaMaps();
@let moreFileCatsWithFilesCount = $moreFileCatsWithFilesCount();

@let requestComments = $requestComments();
@let requestDevices = $requestDevices();
@let devicesInstallQuality = $devicesInstallQuality();
@let mainFileGroups = $mainFileGroups();
@let moreFileGroupsWithFiles = $moreFileGroupsWithFiles();

@let workflowUrlButtonText = $workflowUrlButtonText();
@let workflowUrl = $workflowUrl();

<!--REQUEST BLOCK-->

<section class="x-text-dark-main">
  <p class="x-font-body-3 mt-4.5 mb-1.5 ms-4 opacity-80">
    {{ 'request_form.summary.request' | translate }}
  </p>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <div class="flex items-center justify-between">
      <div class="x-font-body-1-bold">
        {{ request.releaseTime | releaseTimeParser }},
        {{ formatDateWithLocale(request.releaseDate) }}
        @if (request.timezone) {
          <span>({{ request.timezone }})</span>
        }
      </div>
      <x-icon-button
        iconName="x-icon::checklist"
        [clickFunction]="getCheckList.bind(this)"
      />
    </div>
    @if (request.contract) {
      <ng-container
        [ngTemplateOutlet]="inputCopy"
        [ngTemplateOutletContext]="{
          value: request.contract,
          withIcon: true,
        }"
      />
    } @else {
      <p class="x-font-body-4 x-text-dark-75">
        {{ 'request_form.summary.contract_not_specified' | translate }}
      </p>
    }

    @if (request.projectNumber) {
      <div class="x-font-body-4 mt-2.5 -mb-3">
        {{ 'request_form.summary.request_project' | translate }}:
      </div>
      <ng-container
        [ngTemplateOutlet]="inputCopy"
        [ngTemplateOutletContext]="{
          value: request.projectNumber,
        }"
      />
    }

    <div class="x-font-body-4 mt-2.5">
      {{ 'request_form.summary.request_number' | translate }}:
      <span class="x-font-body-4-bold">{{ request.requestNumber }}</span>
    </div>

    <div class="font-medium flex justify-between items-center">
      <span class="x-font-body-4">
        {{ 'request_form.summary.created' | translate }}:
        {{ formatDateWithLocale(request.contractDate) }}
        <div class="x-font-body-4">
          {{ 'request_form.summary.counterparty' | translate }}:
          <span class="font-bold">{{ request.counterPartyName }}</span>
        </div>
        @for (field of request.visibleExtraFields; track field.name) {
          <div class="x-font-body-4">
            {{ field.title }}:
            <span class="font-bold">
              {{ request.getExtraFieldValue(field) }}
            </span>
          </div>
        }
      </span>

      <div>
        @if ($canViewRequestWorkflowsPermission() && $workflowDataExists()) {
          <x-icon-button
            iconName="@tui.archive"
            [size]="44"
            [clickFunction]="openAllWorkflowsLogsModal.bind(this)"
            [tuiHint]="'workflows.events_dialog.open_all_button' | translate"
            class="absolute bottom-[169px]"
          />
        }
        @if ($canManageRequestWorkflows()) {
          <x-icon-button
            iconName="@tui.wrench"
            [size]="44"
            [clickFunction]="openWorkflowsDebuggingSheet.bind(this)"
            [tuiHint]="'debug_panel.debug_button_hint' | translate"
            class="absolute bottom-[117px]"
          />

          <x-icon-button
            iconName="@tui.database"
            [size]="44"
            [clickFunction]="openWorkflowsSubmissionsInfoSheet.bind(this)"
            [tuiHint]="'debug_panel.filling_button_hint' | translate"
            class="absolute bottom-[65px]"
          />
        }
        <x-icon-button
          class="relative"
          iconName="@tui.share"
          [iconSize]="16"
          [clickFunction]="shareRequestLink.bind(this)"
        />
      </div>
    </div>
  </div>
</section>
<!--END REQUEST BLOCK-->

<section class="text-center">
  @if (
    $canViewRequestWorkflowsPermission() &&
    $workflowDataExists() &&
    workflowUrl &&
    workflowUrlButtonText
  ) {
    <button
      [routerLink]="'../' + workflowUrl"
      tuiButton
      size="m"
      class="mt-4.5 w-full !px-4.5"
    >
      {{ workflowUrlButtonText }}
    </button>
  }
</section>

<!--LEASING PRODUCT BLOCK-->

<section class="x-text-dark-main">
  <p class="x-font-body-3 mt-4.5 mb-1.5 ms-4 opacity-80">
    {{ 'request_form.summary.product' | translate }}
  </p>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <div class="flex items-center justify-between">
      <div class="x-font-body-3-bold">
        {{
          request.car || 'request_form.summary.request_car_not_specified'
            | translate
        }}
        <p class="x-font-body-4 opacity-80">
          {{
            request.carType ||
              'request_form.summary.request_car_type_not_specified' | translate
          }}
        </p>
      </div>
      <x-icon-button
        iconName="x-icon::EPTS"
        [disabled]="!ePTS || isOpeningEpts"
        [clickFunction]="openEpts.bind(this)"
      />
    </div>
    @if (request.vin) {
      <ng-container
        [ngTemplateOutlet]="inputCopy"
        [ngTemplateOutletContext]="{
          value: request.vin,
        }"
      />
    } @else {
      <p class="x-font-body-4 x-text-dark-75">
        {{ 'request_form.summary.VIN_not_specified' | translate }}
      </p>
    }
    <div class="mt-6 x-font-body-4 x-text-dark-75 flex-col">
      <p>
        {{ 'request_form.summary.car_year' | translate }}:
        {{ request.carYear || 'common.not_specified_he' | translate }}
      </p>
      <p>
        {{ 'request_form.summary.car_category' | translate }}:
        {{ request.carCategory || 'common.not_specified_he' | translate }}
      </p>
      <p>
        {{ 'request_form.summary.manufacturerCountry' | translate }}:
        {{
          request.manufacturerCountry || 'common.not_specified_she' | translate
        }}
      </p>
    </div>
    <div class="flex justify-between items-center">
      <div>
        <p class="x-font-body-3-bold mt-5">
          {{
            request.deliveryName ||
              'request_form.summary.delivery_name_not_specified' | translate
          }}
        </p>
        <p class="x-font-body-4">
          {{
            request.deliveryAddress ||
              'request_form.summary.delivery_address_not_specified' | translate
          }}
        </p>
      </div>
      @if (request.deliveryAddress) {
        <x-icon-button
          iconName="@tui.navigation"
          [iconSize]="16"
          class="self-end"
          [clickFunction]="openYaMaps.bind(this)"
        />
      }
    </div>
    <p class="x-font-body-4 mt-5 opacity-80">
      {{ 'request_form.summary.delivery_person' | translate }}
    </p>
    <p class="x-font-body-3-bold">
      {{
        request.deliveryPersonName ||
          'request_form.summary.delivery_person_name_not_specified' | translate
      }}
    </p>
    @if (request.deliveryPersonPhone) {
      <div
        class="mt-5 x-white-secondary rounded-xl items-center w-fit px-3.5 py-2.5"
      >
        <a
          class="x-font-body-3-bold"
          [href]="'tel:' + request.deliveryPersonPhone"
          >{{ request.deliveryPersonPhone }}</a
        >
      </div>
    } @else {
      <p class="x-font-body-3-bold">
        {{
          'request_form.summary.delivery_person_phone_not_specified' | translate
        }}
      </p>
    }
  </div>
</section>

<!--END LEASING PRODUCT BLOCK-->

<!--LEASING SUBJECT PERSON BLOCK-->
<section class="x-text-dark-main">
  <p class="typo-body-m mt-4.5 mb-1.5 ms-4 font-medium opacity-80">
    {{ 'request_form.summary.subject_person' | translate }}
  </p>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <p class="x-font-body-3-bold">
      {{
        request.subjFullname ||
          'request_form.summary.subject_person_fullname_not_specified'
          | translate
      }}
    </p>
    @if (request.subjPhone) {
      <div
        class="mt-4 x-white-secondary rounded-xl items-center w-fit px-3.5 py-2.5"
      >
        <a class="x-font-body-3-bold" [href]="'tel:' + request.subjPhone">{{
          request.subjPhone
        }}</a>
      </div>
    } @else {
      <p class="x-font-body-4 x-text-dark-75">
        {{
          'request_form.summary.subject_person_phone_not_specified' | translate
        }}
      </p>
    }
    <div class="mt-6 x-font-body-4 x-text-dark-75 flex-col">
      <p>
        {{ 'request_form.summary.lessee_inn' | translate }}:
        {{ request.subjInn || 'common.not_specified_he' | translate }}
      </p>
      <p>
        {{
          request.subjName || 'request_form.summary.subject_name_not_specified'
            | translate
        }}
      </p>
    </div>
  </div>
</section>
<!--END LEASING SUBJECT PERSON BLOCK-->

<!-- Город выдачи (RELEASE CITY) BLOCK-->
<section class="x-text-dark-main">
  <p class="typo-body-m mt-4.5 mb-1.5 ms-4 font-medium opacity-80">
    {{ 'request_form.summary.release_city' | translate }}
  </p>
  <div
    class="x-card x-card_size_l x-white py-[20px] h-full box-border col-span-1 col-start-3 row-start-1 row-span-1"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <x-request-form-release-city [request]="$request()" />
  </div>
</section>
<!--END Город выдачи (RELEASE CITY) BLOCK-->

<!--Installer BLOCK-->
<section class="x-text-dark-main">
  <div class="flex items-center mb-1.5 mt-4.5 gap-2">
    <p class="typo-body-m ms-4 font-medium opacity-80">
      {{ 'request_form.summary.installer' | translate }}
    </p>
    <p>
      @if (permissionService.canLogistChangeInstaller$ | async) {
        <x-icon-button
          iconName="@tui.pencil"
          [iconSize]="16"
          class="self-end"
          [size]="32"
          [backgroundPrimary]="true"
          [clickFunction]="openInstallerAssignmentSheet.bind(this)"
        />
      }
    </p>
  </div>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <p class="x-font-body-4">
      {{ 'request_form.summary.installer_assignment.contractor' | translate }}:
      <span class="x-font-body-4-bold">
        {{
          request.contractorCounterpartyId?.shortName ||
            request.contractorCounterpartyId?.name ||
            ('common.not_specified_he' | translate)
        }}
      </span>
    </p>
    <p class="x-font-body-4">
      {{ 'request_form.summary.installer_assignment.subdivision' | translate }}:
      <span class="x-font-body-4-bold">
        {{
          request.contractorCounterpartySubdivisionId?.name ||
            ('common.not_specified_he' | translate)
        }}
      </span>
    </p>
    <p class="x-font-body-4">
      {{ 'request_form.summary.installer_assignment.zone' | translate }}:
      <span class="x-font-body-4-bold">
        {{
          request.installZoneNameCashed ||
            request.installZoneId?.name ||
            ('common.not_specified_he' | translate)
        }}
      </span>
    </p>
    <p class="x-font-body-3-bold">
      {{ 'request_form.summary.installer' | translate }}:
      @if (request.installerShort) {
        {{ request.installerShort }}
      } @else {
        {{ 'common.not_specified_he' | translate }}
      }
    </p>
  </div>
</section>
<!--END Installer BLOCK-->

<!--GOODS BLOCK-->
<section class="x-text-dark-main">
  <p
    class="typo-body-m mt-4.5 mb-1.5 ms-4 font-medium opacity-80 cursor-pointer"
    [routerLink]="['/requests', request.requestNumber, 'goods']"
  >
    {{ 'request_form.summary.products_and_services' | translate }} >
  </p>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <x-goods-block
      [requestDevices]="requestDevices"
      [devicesInstallQuality]="devicesInstallQuality"
      [request]="request"
    />
  </div>
</section>

<!--END GOODS BLOCK-->

<!--FILES BLOCK-->
<section class="x-text-dark-main">
  <p
    class="typo-body-m mt-4.5 mb-1.5 ms-4 font-medium opacity-80 cursor-pointer"
    [routerLink]="['/requests', request.requestNumber, 'files', 'installer']"
  >
    {{ 'request_form.summary.files' | translate }} >
  </p>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    @for (group of mainFileGroups; track group.id) {
      <ng-container
        [ngTemplateOutlet]="fileGroup"
        [ngTemplateOutletContext]="{
          group: group,
        }"
      />
    }
    @if (moreFileCatsWithFilesCount > 0) {
      <button
        tuiButton
        type="button"
        (click)="expandedMoreFileCats = !expandedMoreFileCats"
        appearance="flat"
        class="mx-auto block!"
        size="s"
        [iconEnd]="
          expandedMoreFileCats ? '@tui.chevron-up' : '@tui.chevron-down'
        "
      >
        <span class="font-extrabold typo-ui-m">
          {{
            expandedMoreFileCats
              ? ('request_form.summary.collapse' | translate)
              : ('request_form.summary.expand_all' | translate) +
                ' (' +
                moreFileCatsWithFilesCount +
                ')'
          }}
        </span>
      </button>
      <tui-expand [expanded]="expandedMoreFileCats">
        @for (group of moreFileGroupsWithFiles; track group.id) {
          <ng-container
            [ngTemplateOutlet]="fileGroup"
            [ngTemplateOutletContext]="{
              group: group,
            }"
          />
        }
      </tui-expand>
    }
  </div>
</section>

<!--END FILES BLOCK-->

<!--COMMENTS BLOCK-->
<section class="x-text-dark-main">
  <p
    class="typo-body-m mt-4.5 mb-1.5 ms-4 font-medium opacity-80 cursor-pointer"
    [routerLink]="['/requests', request.requestNumber, 'comments']"
  >
    {{ 'request_form.summary.comments' | translate }}
    @if (requestComments?.length) {
      <span tuiBadge class="mx-1 font-medium! mb-1" size="l">{{
        requestComments!.length
      }}</span>
    }
    >
  </p>
  <div
    class="x-card x-card_size_m x-white x-text-dark-main px-0"
    [tuiSkeleton]="!!(isLoading && isInitialLoad)"
  >
    <div class="mt-1">
      <x-request-form-comments
        [isInsideSummary]="true"
        [requestComments]="requestComments"
      />
    </div>
  </div>
</section>
<!--END COMMENTS BLOCK-->

<!-- //////////////////////////////////////////////////////////////////////// -->

<ng-template #inputCopy let-value="value" let-withIcon="withIcon">
  <div
    class="mt-4.5 flex justify-between x-white-secondary rounded-xl items-center w-fit gap-2.5 h-[42px]!"
  >
    <span class="ms-2.5 typo-body-m font-extrabold flex items-center">
      @if (withIcon) {
        <img
          class="me-1.5"
          [ngSrc]="requestIconResolver(request.counterpartyOwnerId.id)"
          alt="cp icon"
          width="16"
          height="16"
        />
      }
      {{ value }}
    </span>
    <button
      class="me-2.5"
      appearance="icon"
      iconStart="@tui.copy"
      size="s"
      tuiIconButton
      [tuiAppearanceState]="true ? 'active' : null"
      (click)="copyToClipboard(value)"
    ></button>
  </div>
</ng-template>

<ng-template #fileGroup let-group="group">
  <p
    class="font-bold mb-4.5 flex items-center gap-2.5"
    [ngClass]="{
      'opacity-50': !group.filesExists,
      'cursor-pointer': group.filesExists,
    }"
    (click)="openLastCatFile(group)"
  >
    @if (group.files?.length) {
      @let file = group.files[group.files.length - 1];
      <x-file-preview
        [src]="file.path | filePreviewUrl"
        [title]="file.filename"
        [fallbackIcon]="'@tui.file'"
        [badge]="file.filename | fileExtension"
        [width]="64"
        [height]="64"
      ></x-file-preview>
    } @else {
      <tui-icon
        [style.border-width.rem]="0.25"
        [icon]="group.multi ? '@tui.folder' : '@tui.file'"
      />
    }
    {{ group.name }}
  </p>
</ng-template>

<x-image-preview
  [files]="$files()"
  [request]="request"
  [showPreviewImageData]="$showPreviewImage"
/>
